/* WM search results enhancer (2026-10-18). Progressive enhancement on top of the Searchanise widget:
   - H1 and breadcrumb read the query ("Results for "great white shark"").
   - Card titles drop the " Wall Decal" suffix (same rule as snippets/wm-card.liquid).
   Safe to fail: without JS the page shows "Search results" and Searchanise's own markup. */
(function () {
  var root = document.getElementById('wms');
  if (!root) return;

  var q = '';
  try { q = (new URLSearchParams(window.location.search).get('q') || '').trim(); } catch (e) {}
  if (q) {
    var h1 = document.getElementById('wms-title');
    if (h1) h1.textContent = 'Results for “' + q + '”';
    var crumb = document.getElementById('wms-crumb');
    if (crumb) crumb.textContent = 'Search: ' + q;
    document.title = q + ' – Search – Wallmonkeys';
  }

  function tidy(scope) {
    var titles = (scope || root).querySelectorAll('#snize_results .snize-title:not([data-wms])');
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i];
      t.setAttribute('data-wms', '1');
      var txt = t.textContent;
      // Same rule as wm-card: drop a trailing " Wall Decal", unless that leaves a dangling word
      // ("Great White Shark with Wall Decal" stays as is).
      if (txt.length > 16 && / Wall Decal$/.test(txt) && !/ (with|amongst|among|and|of|in|on|the|a|an|for|just|at|by|to)$/i.test(txt.slice(0, -11))) {
        t.textContent = txt.slice(0, -11);
      }
    }
  }

  tidy();
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; tidy(); });
    }).observe(root, { childList: true, subtree: true });
  }
})();
